import {
  brand,
  fontWeights,
  fonts,
  marketing,
  marketingBreakpoints,
  marketingSpacing,
  marketingTypeScale,
  maxWidths,
  motion2 as motion,
  radii,
  sectionSpacing,
  shadows
} from "./chunk-RWJTCKM5.mjs";

// src/tokens/marketing-theme.ts
var marketingTheme = {
  colors: {
    ...brand,
    ...marketing
  },
  fonts: fonts.marketing,
  fontWeights,
  typeScale: marketingTypeScale,
  spacing: marketingSpacing,
  sectionSpacing,
  radii,
  shadows,
  motion,
  breakpoints: marketingBreakpoints,
  maxWidth: maxWidths.marketing
};

export {
  marketingTheme
};
//# sourceMappingURL=chunk-OPHPJ2WG.mjs.map